// @flow
import {
  AppBar,
  Container,
  Grid,
  IconButton,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { Close, ArrowBack } from '@material-ui/icons';
import { graphql, navigate } from 'gatsby';
import { makeStyles } from '@material-ui/core/styles';
import * as React from 'react';

import Gallery from '../../components/projects/gallery';
import Markdown from '../../components/styled/markdown';

type Props = {
  data: {
    contentfulService: any,
  },
};

const useStyles = makeStyles((theme) => ({
  close: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.main,
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  container: {
    marginBottom: theme.spacing(4),
  },
}));

const ProjectPage = ({ data: { contentfulService } }: Props) => {
  const classes = useStyles();

  const closeSearchPage = React.useCallback((event) => {
    if (event.keyCode === 27) {
      navigate('/');
    }
  }, []);

  React.useEffect(() => {
    document.addEventListener('keydown', closeSearchPage, false);

    return () =>
      document.removeEventListener('keydown', closeSearchPage, false);
  }, []);

  return (
    <div>
      <AppBar position="fixed" color="secondary">
        <Toolbar>
          <IconButton
            onClick={() => navigate('/')}
            edge="start"
            color="primary"
            aria-label="menu"
          >
            <ArrowBack />
          </IconButton>
          <Typography style={{ flexGrow: 1 }} variant="h6">
            {contentfulService.nombre}
          </Typography>
          <IconButton
            onClick={() => navigate('/')}
            edge="start"
            color="primary"
            aria-label="menu"
            className={classes.close}
          >
            <Close />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Toolbar />

      <Container maxWidth="lg" className={classes.container}>
        <Grid container spacing={3}>
          <Grid item xs={8}>
            <Typography gutterBottom variant="h2">
              {contentfulService.nombre}
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <Markdown>{contentfulService.descripcion.descripcion}</Markdown>
          </Grid>
        </Grid>
      </Container>

      <Gallery
        gallery={contentfulService.galeria}
        nombre={contentfulService.nombre}
      />
    </div>
  );
};

export const query = graphql`
  query ($slug: String!) {
    contentfulService(slug: { eq: $slug }) {
      id
      descripcion {
        descripcion
      }
      galeria {
        gatsbyImageData(
          aspectRatio: 1.5
          quality: 100
          width: 1200
          height: 600
          formats: WEBP
          layout: CONSTRAINED
          cornerRadius: 0
          cropFocus: CENTER
        )
        id
        fluid(maxWidth: 1500, quality: 100) {
          srcWebp
        }
      }
      nombre
    }
  }
`;

export default ProjectPage;
